import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Card, CardBody } from "@heroui/react";
import PageTemplate from "../components/PageTemplate";

export default function EventSchedule() {
  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in">
            Event Schedule
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Event Overview */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          <Card className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl">
            <CardBody className="p-6 sm:p-8">
              <div className="text-4xl sm:text-6xl mb-4 sm:mb-6">📅</div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-text font-bold text-coral mb-4 sm:mb-6">
                NJ Naach 3.0
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-center">
                <div>
                  <div className="text-lg sm:text-2xl font-text font-bold text-teal-600 mb-2">🗓️ Date</div>
                  <p className="text-sm sm:text-base text-teal-700 font-text">February 20-22, 2026</p>
                </div>
                <div>
                  <div className="text-lg sm:text-2xl font-text font-bold text-teal-600 mb-2">📍 Location</div>
                  <p className="text-sm sm:text-base text-teal-700 font-text">Patriots Theater, Trenton, NJ</p>
                </div>
                <div>
                  <div className="text-lg sm:text-2xl font-text font-bold text-teal-600 mb-2">⏰ Time</div>
                  <p className="text-sm sm:text-base text-teal-700 font-text">TBD - Stay Tuned!</p>
                </div>
                <div>
                  <div className="text-lg sm:text-2xl font-text font-bold text-teal-600 mb-2">🎫 Tickets</div>
                  <p className="text-sm sm:text-base text-teal-700 font-text">TBD - Stay Tuned!</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Day 1 Schedule */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-text font-bold text-coral text-center mb-8 sm:mb-12">
            Day 1 - Friday, February 20
          </h2>
          
          {/* Stay Tuned Card */}
          <Card className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-2xl">
            <CardBody className="p-8 sm:p-12">
              <div className="text-6xl sm:text-8xl mb-6 sm:mb-8 animate-bounce" style={{ animationDuration: '3s' }}>
                📅
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-text font-bold text-coral mb-4 sm:mb-6">
                Stay Tuned for Schedule Details!
              </h3>
              <p className="text-lg sm:text-xl text-teal-600 font-text mb-6 sm:mb-8 leading-relaxed">
                We're finalizing the exciting schedule for NJ Naach 3.0. 
                Check back soon for detailed timing and events!
              </p>
              <div className="bg-gradient-to-r from-coral-100 to-sky-100 rounded-2xl p-4 sm:p-6">
                <p className="text-base sm:text-lg text-coral-600 font-text font-semibold">
                  🎪 More Details Coming Soon!
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Day 2 Schedule */}
      <div className="py-16 px-4 bg-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-text font-bold text-coral text-center mb-12">
            Day 2 - Friday, February 21
          </h2>
          
          {/* Stay Tuned Card */}
          <Card className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-2xl">
            <CardBody className="p-8 sm:p-12">
              <div className="text-6xl sm:text-8xl mb-6 sm:mb-8 animate-bounce" style={{ animationDuration: '3s' }}>
                🏆
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-text font-bold text-coral mb-4 sm:mb-6">
                Competition Details Coming Soon!
              </h3>
              <p className="text-lg sm:text-xl text-teal-600 font-text mb-6 sm:mb-8 leading-relaxed">
                We're working on the exciting competition schedule for Day 2. 
                Stay tuned for updates on registration and event details!
              </p>
              <div className="bg-gradient-to-r from-sky-100 to-coral-100 rounded-2xl p-4 sm:p-6">
                <p className="text-base sm:text-lg text-coral-600 font-text font-semibold">
                  🎪 Registration Details Coming Soon!
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      
      {/* Day 3 Schedule */}
      <div className="py-16 px-4 bg-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-text font-bold text-coral text-center mb-12">
            Day 3 - Saturday, February 22
          </h2>
          
          {/* Stay Tuned Card */}
          <Card className="bg-white/80 backdrop-blur-sm border border-peach-200 shadow-2xl">
            <CardBody className="p-8 sm:p-12">
              <div className="text-6xl sm:text-8xl mb-6 sm:mb-8 animate-bounce" style={{ animationDuration: '3s' }}>
                🎉
              </div>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-text font-bold text-coral mb-4 sm:mb-6">
                Final Day Details Coming Soon!
              </h3>
              <p className="text-lg sm:text-xl text-teal-600 font-text mb-6 sm:mb-8 leading-relaxed">
                The grand finale day schedule is being finalized. 
                Check back soon for details!
              </p>
              <div className="bg-gradient-to-r from-coral-100 to-peach-100 rounded-2xl p-4 sm:p-6">
                <p className="text-base sm:text-lg text-coral-600 font-text font-semibold">
                  🎆 Awards & Celebration Coming Soon!
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-coral to-teal py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-text font-bold text-white mb-6">
            Ready to Join the Celebration?
          </h2>
          <p className="text-xl text-white/90 mb-8 font-text">
            Secure your spot at NJ Naach 3.0 and be part of the most exciting dance competition on the Jersey Shore
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              as={RouterLink}
              to="/tickets"
              size="lg"
              className="bg-white text-teal-700 px-8 py-3 rounded-full font-button font-semibold hover:bg-cream-50 transition-all duration-300"
            >
              Buy Tickets Now
            </Button>
            <Button
              as={RouterLink}
              to="/teams"
              size="lg"
              className="bg-peach text-coral-700 px-8 py-3 rounded-full font-button font-semibold hover:bg-peach-400 transition-all duration-300"
            >
              View Teams
            </Button>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
}
